import { AddSGBPCategoryData } from "../../ViewApproveCategoryCriteria/data/AddSGBPCategory.Data";

export const hideAndShowFields = ( data, value ) => {
    const isChannelOne = value?.value === 1;
    return {
      ...data,
      formFields: data.formFields.map( ( field ) => {
        if ( field.id === "subCategory" || field.id === "type" ) {
          return {
            ...field,
            style: {
              ...field.style,
              containerCss: isChannelOne
                ? "col-lg-4 mb-3"
                : "d-none",
            },
            validation: isChannelOne ? [ { type: "require" } ] : [],
          };
        }
        return field;
      } ),
      initialState: {
        ...data.initialState,
        subCategory: isChannelOne ? data.initialState.subCategory : null,
        type: isChannelOne ? data.initialState.type : null,
      },
    };
};
  
export const setFieldParameter = (apiResponse) => {
    AddSGBPCategoryData.initialState.channel = apiResponse.channelId || null;
    AddSGBPCategoryData.initialState.category = apiResponse?.categoryL1Id || null;
    AddSGBPCategoryData.initialState.subCategory = apiResponse?.subCategoryL2Id || null;
    AddSGBPCategoryData.initialState.type = apiResponse?.typeL3Id || null;
    AddSGBPCategoryData.initialState.code = apiResponse?.criteriaCodeId || null;
    AddSGBPCategoryData.initialState.certificateTemplate = apiResponse?.certificateTemplateId || null;
};

export const getCertificateTemplateOptions = (dropdownData, channelId) => {
  const channel = Number(channelId);
  const dropdownName =
    channel === 1 ? "Certificate Template" :
    channel === 2 ? "SGBS Certificate Template" : null;

  if (!dropdownName || !Array.isArray(dropdownData)) return [];

  return dropdownData
    .filter((item) => item.dropdownName === dropdownName)
    .map((item) => ({ value: item.id, label: item.name }));
};

export const applyCertificateTemplateOptions = (form, options) => ({
  ...form,
  formFields: form.formFields.map((field) =>
    field.id === "certificateTemplate"
      ? { ...field, fieldSetting: { ...field.fieldSetting, options } }
      : field
  ),
});

// in hideAndShowFields, change the first line to:
// const isChannelOne = Number(value?.value ?? value) === 1;